import { Link } from "react-router-dom";
import Button from "@/common/components/Button";
import { ArrowBigRight } from "lucide-react";
import { TmaisRaffleData } from "../types/tmaisRaffles.type";
import { formatDate } from "@/common/utils/formatters";
import { tmaisRafflesStatusStrategy } from "../constants/statusOptions.constant";

export class TmaisRafflesTransformer {
  static tableTransformer() {
    return (tmaisRaffles: TmaisRaffleData[]) => {
      return tmaisRaffles.map((raffle) => {
        return {
          ...raffle,
          status: raffle.status ? tmaisRafflesStatusStrategy[raffle.status as keyof typeof tmaisRafflesStatusStrategy] : '--',
          available_until: raffle?.available_until ? formatDate(new Date(raffle.available_until)) : undefined,
          available_from: raffle?.available_from ? formatDate(new Date(raffle.available_from)) : undefined,
          actions: (
            <Link to={raffle.id}>
              <Button name="access_tmais_raffle_button" variant='link-white' className="w-full" operationKlassToCheckPermission="Establishment::Tmais::Raffles::Show">
                <ArrowBigRight />
              </Button>
            </Link>
          )
        };
      });
    };
  }
}
